import React from 'react';
import '../styles/layout.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025 Your Company. All rights reserved.</p>
    </footer>
  );
};

export default Footer;